/* eslint-disable import/no-cycle */
import { Select } from '@chakra-ui/core';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MultiChoiceOption } from '../../../../questionnaireTemplate.types';
import { QuestionnaireTemplateStore } from '../../../../store/questionnaireTemplateModel';
import { INLINE_SELECT_PROPS } from './questionValidationRules.style';
import { OptionSelectionCount, ValidationOperator } from './questionValidationRules.types';

const EMPTY_OPTIONS: MultiChoiceOption[] = [];

interface QuestionValidationSelectionCountSelectProps {
  elementId: string;
  selectionCount: OptionSelectionCount;
  operator: ValidationOperator;
  onChange: (newCount: OptionSelectionCount) => void;
}

export const QuestionValidationSelectionCountSelect = React.memo<QuestionValidationSelectionCountSelectProps>(
  function QuestionValidationSelectionCountSelect({ elementId, selectionCount, operator, onChange }) {
    const { t } = useTranslation('questionnaireTemplate');
    const options = QuestionnaireTemplateStore.useStoreState(
      (state) => state.entities.elements[elementId]?.options ?? /* istanbul ignore next */ EMPTY_OPTIONS,
    );

    const selectionCountOptions = useMemo(() => {
      const counts = Array.from({ length: options.length }, (_, i) => i + 1);
      if (operator === ValidationOperator.DOES_NOT_HAVE_ANSWER) {
        return counts.slice(0, -1);
      }
      return counts;
    }, [options.length, operator]);

    const handleSelectionCountChange = useCallback(
      (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;
        onChange(value as OptionSelectionCount);
      },
      [onChange],
    );

    return (
      <Select display="inline-block" {...INLINE_SELECT_PROPS} value={selectionCount} onChange={handleSelectionCountChange}>
        {selectionCountOptions.map((n) => (
          <option key={n} value={n}>
            {n}
          </option>
        ))}
        <option value="any">{t(`formBuilder.canvas.element.validationRules.any`)}</option>
      </Select>
    );
  },
);
